import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type helpPermissionType = 'help_view';

export const helpPermissionMatrix: IPermissionMatrix<helpPermissionType> = {
  help_view: [UserRole.user]
};
